/* Native radio groups supply keyboard behavior. Delegation also covers editor section reloads. */
document.addEventListener('change', (event) => {
  const option = event.target.closest('[data-ss-model-colour]');
  if (!option) return;
  const card = option.closest('.ss-models__card');
  if (!card) return;
  card.querySelector('[data-ss-colour-name]').textContent = option.dataset.colour;
  card.querySelector('.ss-models__price').textContent = option.dataset.price;
  card.querySelectorAll('[data-ss-model-link]').forEach(link => { link.href = option.dataset.url; });
  card.querySelector('[data-ss-model-status]').textContent = option.dataset.available === 'true' ? '' : 'Sold out';
  if (card.querySelector('[data-ss-image-override]')) return;
  const brief = card.querySelector('.ss-media-brief__title');
  if (brief) brief.textContent = option.dataset.colour + ' · Product photograph';
  let image = card.querySelector('.ss-models__shot > .ss-responsive-image > img, .ss-models__shot > img');
  if (!image && !brief && option.dataset.image) {
    image = document.createElement('img');
    image.width = 800;
    image.height = 800;
    image.loading = 'lazy';
    card.querySelector('.ss-models__shot').append(image);
  }
  if (image) {
    image.hidden = !option.dataset.image;
    if (option.dataset.image) {
      image.closest('picture')?.querySelectorAll('source').forEach(source => source.remove());
      const picture = image.closest('picture');
      picture?.style.setProperty('--ss-image-position', option.dataset.imagePosition || '50% 50%');
      picture?.style.setProperty('--ss-image-position-mobile', option.dataset.imagePosition || '50% 50%');
      image.src = option.dataset.image;
      image.removeAttribute('srcset');
      image.alt = option.dataset.imageAlt || card.querySelector('.ss-models__name').textContent.trim();
    }
  }
});
